import { useAuthHeader } from "react-auth-kit";
import { toast } from "react-toastify";
import FormModal from "../../../../components/Modal/FormModal";
import React from "react";
import { updateNotification } from "../api/notificationsApi";
import PushNotificationForm from "./PushNotificationForm";

const EditPushNotificationModal = ({
  notification,
  onSuccess,
  isOpen,
  onClose,
}) => {
  const authHeader = useAuthHeader();

  const handleSubmit = async (formData) => {
    try {
      await updateNotification({ ...notification, ...formData }, authHeader());
      toast.success("Notification has been updated!");
      onSuccess();
    } catch (e) {
      toast.error(e.message);
    }
  };

  return (
    <FormModal isOpen={isOpen} onClose={onClose} title="Edit Push Notification">
      <PushNotificationForm
        initialData={notification}
        onSubmit={handleSubmit}
        onCancel={onClose}
        isNew={false}
      />
    </FormModal>
  );
};

export default EditPushNotificationModal;
